<template>
    <!-- 列表部分 -->
    <div class="listContent">
        <div  class="search-content conditionSearchBox mt-20">
            <div class="modeChoose flex">
                <span @click="chengeModel(item)" v-for="item in menuData" :key="item.value" :class="activeValue==item.value ? 'active':''" class="tableModle item">{{item.label}}<span v-if="activeValue==item.value">（{{tableData.length}}）</span></span>
            </div>
        </div>
        <div class="listBox mt-20">
             <!-- 表格 -->
            <div v-loading="loadingStatus" class="table-content mt-15">
                <el-table class="table-fixed-col" ref="multipleTable" border :data="tableData" style="width: 100%">
                    <el-table-column key="index" type="index" :width="getTableHeaderWidthByOrderCol()"  align="center" label="序号"
                        fixed="left">
                        <template slot-scope="scope">
                            <TableSort :index="scope.$index" :page="params.page" :pagesize="params.pagesize" />
                        </template>
                    </el-table-column>
                    <el-table-column min-width="140" show-overflow-tooltip key="classname" align="center" prop="classname" label="班级名称">
                    </el-table-column>
                    <el-table-column min-width="140" show-overflow-tooltip key="classcoursename" align="center" prop="classcoursename" label="课程名称">
                    </el-table-column>
                    <el-table-column min-width="140" show-overflow-tooltip key="periodname" align="center" prop="periodname" label="课时名称">
                        <template slot-scope="scope">
                            <span class="classcoursename" @click="goDetail(scope.row)">{{scope.row.periodname}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="140"  key="perioddate" align="center" prop="perioddate" label="课程时间">
                    </el-table-column>
                    <el-table-column min-width="140" key="starttime" align="center" prop="starttime" label="课时日期">
                    </el-table-column>
                    <el-table-column min-width="120" key="endtime" show-overflow-tooltip align="center" prop="endtime" label="课时时间">
                    </el-table-column>
                    <el-table-column width="100" key="periodmodename" align="center" prop="periodmodename" label="授课模式">
                    </el-table-column>
                    <el-table-column min-width="120" show-overflow-tooltip key="teachername" align="center" prop="teachername" label="授课老师">
                    </el-table-column>
                    <el-table-column width="100" key="statusname" align="center" prop="statusname" label="授课状态">
                    </el-table-column>
                    <el-table-column :width="getTableHeaderWidthByOpButton3()" fixed="right" key="set" align="right" label="操作">
                        <template slot-scope="scope">
                            <div class="color-brand flex jc-sb ai-c pointer">
                                <span @click="editClass(scope.row)" v-if="scope.row.status === 10" class="color-brand pointer" >编辑</span>
                                <span v-else class="color-text-sec">编辑</span>
                                <span @click="syEdit(scope.row)" v-if="scope.row.status === 10" class="color-brand pointer">顺延</span>
                                <span v-else class="color-text-sec">顺延</span>
                                <span @click="playVideo(scope.row)" v-if="scope.row.periodmode === 1 && scope.row.contentway === 1 && scope.row.filekeyurl" class="color-brand pointer">预览</span>
                                <span v-else class="color-text-sec">预览</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 编辑 -->
            <ClassEdit ref="ClassEdit" />
            <!-- 顺延课时 -->
            <PostponeClassHours ref="PostponeClassHours" />
            <!-- 预览 -->
            <VideoPreview ref="VideoPreview" />
        </div>
    </div>
</template>
<script>
import {getScheduleByTable} from '@/api/measApi/teachManagement.js'
import {getTableDefaultPageSize} from '@/assets/measAssets/js/tools.js'
import TableSort from '@/components/measComponents/tableSort/tableSort.vue'
import ClassEdit from '../../components/classEdit.vue'
import PostponeClassHours from './postponeClassHours.vue'
import VideoPreview from '@/components/measComponents/videoPreview/videoPreview.vue'
export default {
    data(){
        return {
            loadingStatus: false,
            params: {
                campuscode: '',
                campusname: '',
                classcode: this.$route.query.classCode,
                classcoursecode: this.$route.query.code,
                classcoursename: '',
                classname: '',
                enddate: '',
                periodcode: '',
                periodname: '',
                startdate: ''
            },
            tableData: [],
            menuData: [
                {label: '全部', value: 0},
                {label: '线上录播', value: 1},
                {label: '线上直播', value: 2},
                {label: '线下现场', value: 3},
                {label: '未设置', value: 4}
            ],
            activeValue: 0,
            selectTableData: [],
            step: 1
        }
    },
    components: {
        TableSort,
        ClassEdit,
        PostponeClassHours,
        VideoPreview
    },
    created(){
        
    },
    methods: {
        init(){
            if(this.step === 1){
                this.getTableList()   
            }
        },
        getTableList(){
            this.loadingStatus = true
            getScheduleByTable(this.params).then(res => {
                this.step++
                this.loadingStatus = false
                this.tableData = JSON.parse(JSON.stringify(res.data))
                this.selectTableData = JSON.parse(JSON.stringify(res.data))
            })
        },
        triggerSearch(){
            this.getTableList()
        },
        resetSearchCondition(){
            this.params.classname = ''
            this.params.campusname = ''
            this.params.classcoursename = ''
            this.params.periodname = ''
            this.getTableList()
        },
        chengeModel(item){
            this.activeValue = item.value
            if(item.value === 0){
                this.tableData = this.selectTableData
            }else if(item.value === 1){
                this.tableData = this.selectTableData.filter(res => {
                    return res.periodmode === 1 && res.contentway === 1
                })
            }else if(item.value === 2){
                this.tableData = this.selectTableData.filter(res => {
                    return res.periodmode === 1 && res.contentway === 2
                })
            }else if(item.value === 3){
                this.tableData = this.selectTableData.filter(res => {
                    return res.periodmode === 2
                })
            }else if(item.value === 4){
                this.tableData = this.selectTableData.filter(res => {
                    return res.contentway === 0
                })
            }
        },
        playVideo(row){
            this.$refs.VideoPreview.open(row.filekeyurl)
        },
        editClass(row){
            this.$refs.ClassEdit.init(row.code, row.classcoursecode)
        },
        syEdit(row){
            this.$refs.PostponeClassHours.init(row)
        },
        goDetail(row){
            this.$router.push({ name: 'CoursePeriodDetail', query: { code: row.classcoursecode, classCode: row.classcode, coursePeriodCode: row.code } })
        }
    }
}
</script>
<style lang="scss">
.classcoursename{
    color: #0B75FA;
    cursor: pointer;
}
.modeChoose{
        align-items: center;
        width: 100%;
        border-radius: 4px;
        .item{
            font-size: 12px;
            padding: 6px 16px;
            border: 1px solid #E4E7EC;
            cursor: pointer;
        }
        .tableModle{
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
        }
        .dateModle{
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
            border-left: none;
        }
        .active{
            background: #0B75FA;
            color: white;
        }
    }
</style>